import { render, staticRenderFns } from "./capacitiesSidebar.vue?vue&type=template&id=1daecbe8&"
import script from "./capacitiesSidebar.vue?vue&type=script&lang=js&"
export * from "./capacitiesSidebar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports